
import { defineComponent } from 'vue'
import { iLov } from '../../../LovsManagement'
import { VCodeMirror } from 'vue3-code-mirror'
import Dropdown from 'primevue/dropdown'

export default defineComponent({
    name: 'lovs-management-query',
    components: { Dropdown, VCodeMirror },
    props: {
        selectedLov: { type: Object, required: true },
        selectedQuery: { type: Object },
        datasources: { type: Array },
        codeInput: { type: Object }
    },
    emits: ['touched'],
    data() {
        return {
            lov: {} as iLov,
            query: {} as any,
            code: '',
            dirty: false,
            codeMirror: {} as any,
            options: {
                mode: 'text/x-mysql',
                indentWithTabs: true,
                smartIndent: true,
                lineWrapping: true,
                matchBrackets: true,
                autofocus: true,
                theme: 'eclipse',
                lineNumbers: true
            },
            cursorPosition: null
        }
    },
    watch: {
        selectedLov() {
            this.loadLov()
            this.loadSelectedQuery()
            this.setupCodeMirror()
        },
        codeInput() {
            this.setupCodeMirror()
            this.cursorPosition = this.codeMirror.getCursor()
            this.codeMirror.replaceRange('${' + this.codeInput?.code + '}', this.cursorPosition)
        }
    },
    computed: {
        lovType(): string {
            return this.selectedLov.itypeCd
        }
    },
    async created() {
        this.loadLov()
        this.loadSelectedQuery()
        this.setupCodeMirror()
    },
    methods: {
        loadLov() {
            this.lov = this.selectedLov as iLov
        },
        loadSelectedQuery() {
            this.query = this.selectedQuery as any
            if (this.query) {
                this.code = this.query.query ?? ''
            }
        },
        setupCodeMirror() {
            if (this.$refs.codeMirror) {
                this.codeMirror = (this.$refs.codeMirror as any).editor as any
            }
        },
        onKeyUp() {
            this.query.query = this.code
            this.$emit('touched')
        }
    }
})
